import React, { useState } from 'react';
import { Button, FlexBox } from '@vp/swan';
import { Request } from '@99designs/graph-utils/types';
import { __ } from '@99designs/i18n';
import { DraftBriefCard } from './DraftBriefCard';

const numberOfDraftBriefsToShow = 5;

const DraftBriefs: React.FC<{ requests: Request[] }> = ({ requests }) => {
    const [allBriefsExpanded, setAllBriefsExpanded] = useState(false);

    return (
        <>
            <FlexBox flexDirection="column" gap="between-subsections">
                {requests
                    .slice(0, allBriefsExpanded ? requests.length : numberOfDraftBriefsToShow)
                    .map((request) => {
                        return request.brief ? (
                            <DraftBriefCard key={request.brief.id} request={request} />
                        ) : null;
                    })}
            </FlexBox>
            {!allBriefsExpanded && requests.length > numberOfDraftBriefsToShow && (
                <FlexBox alignItems="center" justifyContent="center" mt="between-subsections">
                    <Button skin="secondary" onClick={() => setAllBriefsExpanded(true)}>
                        {__('View all draft briefs')}
                    </Button>
                </FlexBox>
            )}
        </>
    );
};

export { DraftBriefs };
